import { _APIHandler } from "../utils/helper";

let baseUrl = "purchase_requests";
export const fetchPurchaseRequests = (queryParams) => _APIHandler.get(`${baseUrl}`, { params: queryParams });
export const fetchPurchaseRequest = (id) => _APIHandler.get(`${baseUrl}/${id}`);
export const createPurchaseRequest = (data) => _APIHandler.post(`${baseUrl}`, data,);